import { getMessages } from '../../../../../../../../store/constants';

export const NOTIFICATION_LIST_ITEM_REMOVE_BUTTON_TOOLTIP = getMessages().getText('tooltip.notifications_before_due_date.list_item.button.remove.text');
